import {passwordGroups} from '@nursio-link/common/authorization';

import {useGroupAuthorize, useSignOut} from '@/hooks/useAuth';
import {graphqlClient} from '@/services/graphqlClient';
import {useGetConfigsQuery} from '@/services/graphqlHooks';

import IdleTimerCountdown from './IdleTimerCountdown';

const isDev = !import.meta.env.PROD;
const devTimeout = 3600;

const IdleTimer = () => {
  const isLongSession = useGroupAuthorize(passwordGroups);
  const signOut = useSignOut();

  const autoLogoutKey = isLongSession
    ? 'ADMIN_AUTO_LOGOUT_TIME'
    : 'EMPLOYEE_AUTO_LOGOUT_TIME';

  const {data: configsData} = useGetConfigsQuery(graphqlClient, undefined, {
    staleTime: Infinity,
  });

  const configs = configsData?.getConfigs || [];
  const prodTimeout =
    configs.find(config => config.key === autoLogoutKey)?.value.numberValue ||
    600;

  const timeout = isDev ? devTimeout : prodTimeout;

  const onIdle = () => {
    signOut.mutate();
  };

  return <IdleTimerCountdown timeout={timeout} onIdle={onIdle} />;
};

export default IdleTimer;
